import * as React from "react";
import { SVGProps } from "react";
const SvgLogoSlack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-slack_svg__a)">
      <g
        clipPath="url(#logo-slack_svg__b)"
        fillRule="evenodd"
        clipRule="evenodd"
      >
        <path
          d="M6.6 0a1.8 1.8 0 1 0 0 3.6h1.8V1.8C8.402.807 7.596.001 6.6 0Zm0 4.8H1.8a1.8 1.8 0 0 0 0 3.6h4.8a1.8 1.8 0 1 0 0-3.6Z"
          fill="#36C5F0"
        />
        <path
          d="M18 6.6a1.8 1.8 0 0 0-3.6 0v1.8h1.8A1.8 1.8 0 0 0 18 6.6Zm-4.8 0V1.8a1.8 1.8 0 0 0-3.6 0v4.8a1.8 1.8 0 1 0 3.6 0Z"
          fill="#2EB67D"
        />
        <path
          d="M11.4 18a1.8 1.8 0 1 0 0-3.6H9.6v1.8c-.001.993.805 1.799 1.8 1.8Zm0-4.8h4.8a1.8 1.8 0 0 0 0-3.6h-4.8a1.8 1.8 0 0 0 0 3.6Z"
          fill="#ECB22E"
        />
        <path
          d="M0 11.4a1.8 1.8 0 0 0 3.6 0V9.6H1.8A1.8 1.8 0 0 0 0 11.4Zm4.8 0v4.8a1.8 1.8 0 0 0 3.6 0v-4.799a1.8 1.8 0 0 0-3.6-.001Z"
          fill="#E01E5A"
        />
      </g>
    </g>
    <defs>
      <clipPath id="logo-slack_svg__a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
      <clipPath id="logo-slack_svg__b">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoSlack;
